var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 512 0 L 512 512 L 0 512 L 0 0 Z M 253 69 L 248 71 L 240 81 L 240 259 L 202 221 L 195 218 L 190 218 L 183 221 L 176 230 Q 174 239 178 244 L 248 313 L 253 315 Q 264 316 269 310 L 318 261 Q 317 258 320 259 Q 330 252 336 240 Q 338 230 334 226 Q 330 220 323 218 L 318 218 L 311 221 L 273 259 L 272 81 L 270 77 Q 266 68 253 69 Z M 81 240 L 77 242 Q 71 245 69 253 L 69 270 L 70 271 L 70 280 L 71 281 L 72 293 L 81 324 Q 94 356 115 380 Q 137 405 169 422 Q 185 430 204 436 L 220 440 L 241 442 L 242 443 L 271 443 L 272 442 L 287 441 L 302 438 L 324 431 Q 356 418 380 397 Q 404 375 421 346 L 435 313 L 441 288 L 442 273 L 443 272 L 443 252 L 441 248 L 432 240 Q 422 238 418 242 L 411 251 L 409 280 L 405 298 L 398 318 Q 387 343 369 362 Q 348 384 318 398 L 298 405 L 272 410 L 241 410 Q 239 407 233 409 L 203 401 L 176 388 L 147 366 L 126 340 L 113 315 L 105 290 L 103 279 L 103 271 L 102 270 L 102 254 L 99 247 Q 95 238 81 240 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 252.5 69 L 260 69.5 L 252.5 70 L 252.5 69 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 261.5 70 Q 267.6 71.4 270 76.5 L 264.5 72 Q 260.8 71.7 261.5 70 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 247.5 71 L 242.5 77 L 247.5 71 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 240.5 80 L 241 82.5 L 240 82.5 L 240.5 80 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 271.5 80 L 272 82.5 L 271 82.5 L 271.5 80 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 189.5 218 L 195 218.5 L 189.5 219 L 189.5 218 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 317.5 218 L 323 218.5 L 317.5 219 L 317.5 218 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 182.5 221 L 179 225.5 L 176.5 232 L 176 229.5 L 182.5 221 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 201.5 221 L 239.5 260 L 201.5 221 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 310.5 221 L 272.5 260 L 310.5 221 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 329.5 221 Q 334.9 224.1 336 231.5 L 335 231.5 Q 333.4 224.1 329.5 221 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 176.5 237 L 177 239.5 L 176 239.5 L 176.5 237 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 335.5 237 L 336 239.5 L 335 239.5 L 335.5 237 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 80.5 240 L 83 240.5 L 80.5 241 L 80.5 240 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 87.5 240 Q 95.8 240.8 99 246.5 L 94.5 243 L 87.5 241 L 87.5 240 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 421.5 240 L 425 240.5 Q 417.4 241.4 414 246.5 L 412.5 249 L 413 247.5 L 417.5 242 L 421.5 240 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 429.5 240 L 432 240.5 L 429.5 241 L 429.5 240 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 76.5 242 L 72 247.5 L 70.5 251 L 70 249.5 L 76.5 242 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 435.5 242 L 443 251.5 L 443 271.5 L 442 271.5 L 442 251.5 L 435.5 242 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 178.5 243 L 247.5 313 L 178.5 243 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 333.5 243 L 332 245.5 L 319.5 259 Q 317.3 258.3 318 260.5 L 268.5 310 L 261.5 314 L 261.5 313 L 264.5 312 L 333.5 243 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 69.5 252 L 70 269.5 L 69 269.5 L 69.5 252 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 101.5 253 L 102 266.5 L 101 266.5 L 101.5 253 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 410.5 254 L 411 268.5 L 410 268.5 L 410.5 254 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 102.5 270 L 103 276.5 L 102 276.5 L 102.5 270 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 409.5 272 L 410 277.5 L 409 277.5 L 409.5 272 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 70.5 273 L 71 279.5 L 70 279.5 L 70.5 273 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 441.5 275 L 442 280.5 L 441 280.5 L 441.5 275 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 103.5 279 L 104 282.5 L 103 282.5 L 103.5 279 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 408.5 280 L 409 283.5 L 408 283.5 L 408.5 280 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 71.5 282 L 72 286.5 L 71 286.5 L 71.5 282 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 440.5 283 L 441 287.5 L 440 287.5 L 440.5 283 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 104.5 285 L 105 287.5 L 104 287.5 L 104.5 285 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 407.5 285 L 408 288.5 L 407 288.5 L 407.5 285 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 72.5 288 L 73 292.5 L 72 292.5 L 72.5 288 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 439.5 289 L 440 292.5 L 439 292.5 L 439.5 289 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 105.5 290 L 106 292.5 L 105 292.5 L 105.5 290 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 406.5 290 L 407 292.5 L 406 292.5 L 406.5 290 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 73.5 294 L 74 296.5 L 73 296.5 L 73.5 294 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 106.5 294 L 108 299.5 L 107 299.5 L 106.5 294 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 405.5 294 L 406 296.5 L 405 296.5 L 405.5 294 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 438.5 294 L 439 297.5 L 438 297.5 L 438.5 294 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 74.5 298 L 75 301.5 L 74 301.5 L 74.5 298 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 404.5 298 L 405 300.5 L 400.5 312 L 400 310.5 L 404.5 298 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 437.5 299 L 438 301.5 L 437 301.5 L 437.5 299 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 436.5 303 L 437 305.5 L 436 305.5 L 436.5 303 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 76.5 306 L 77 308.5 L 76 308.5 L 76.5 306 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 111.5 310 L 113 313.5 L 112 313.5 L 111.5 310 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 434.5 310 L 435 312.5 L 431.5 321 L 431 319.5 L 434.5 310 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 399.5 313 L 400 314.5 L 398.5 317 L 398 315.5 L 399.5 313 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 252.5 314 L 260 314.5 L 252.5 315 L 252.5 314 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 113.5 315 L 116 320.5 L 115 320.5 L 113.5 315 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 81.5 322 L 83 325.5 L 82 325.5 L 81.5 322 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 395.5 322 L 396 323.5 L 392.5 329 L 393 327.5 L 395.5 322 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 429.5 325 L 430 326.5 L 427.5 331 L 427 329.5 L 429.5 325 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 83.5 327 L 86 332.5 L 85 332.5 L 83.5 327 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 120.5 330 L 126 338.5 L 124 337.5 L 120.5 330 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 390.5 332 L 390 333.5 L 388.5 336 L 389 334.5 L 390.5 332 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 425.5 334 L 426 335.5 L 419.5 347 L 420 345.5 L 425.5 334 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 387.5 337 L 387 338.5 L 382.5 345 L 384 342.5 L 387.5 337 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 126.5 340 L 133 348.5 L 130 346.5 L 126.5 340 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 92.5 346 L 96 351.5 L 94 350.5 L 92.5 346 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 381.5 346 L 380 348.5 L 376.5 353 L 379 349.5 L 381.5 346 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 418.5 348 L 418 349.5 L 413.5 357 L 414 355.5 L 418.5 348 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 133.5 350 L 147 366 L 162 378.5 L 158.5 376 L 146 365.5 L 133.5 350 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 96.5 353 L 97.5 355 L 96.5 353 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 375.5 354 L 370 360.5 L 362.5 369 L 354.5 376 L 361.5 368 L 369 361.5 L 375.5 354 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 98.5 356 L 104 363.5 L 101 361.5 L 98.5 356 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 412.5 358 L 411.5 360 L 412.5 358 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 410.5 361 L 409 363.5 L 406.5 367 L 408 364.5 L 410.5 361 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 104.5 365 Q 116.8 382.2 132.5 396 L 139 401.5 L 133.5 397 L 115 379.5 L 104.5 365 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 405.5 368 L 403 371.5 Q 393.3 386.3 379.5 397 L 397 378.5 L 405.5 368 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 352.5 376 L 349.5 380 L 337.5 388 L 338.5 386 L 352.5 376 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 163.5 379 L 165.5 382 L 163.5 379 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 167.5 382 L 172 385.5 L 170.5 385 L 167.5 382 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 173.5 386 L 174.5 388 L 173.5 386 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 176.5 388 L 182 391.5 L 180.5 391 Q 176.5 390.5 176.5 388 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 335.5 388 L 334.5 390 L 332.5 391 L 333.5 389 L 335.5 388 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 328.5 392 L 327.5 394 L 320.5 397 L 320.5 396 L 328.5 392 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 187.5 394 L 190 395.5 L 188.5 396 L 187.5 394 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 193.5 397 L 202 400.5 L 200.5 401 L 193.5 398 L 193.5 397 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 377.5 397 L 373.5 402 L 377.5 397 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 315.5 398 L 317 398.5 L 313.5 400 L 313.5 399 L 315.5 398 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 310.5 400 L 312 400.5 L 298.5 405 L 298.5 404 L 310.5 400 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 140.5 402 L 147 407.5 L 144.5 406 L 140.5 402 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 206.5 402 L 211 403.5 L 208.5 404 L 206.5 402 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 371.5 402 L 368.5 406 L 365.5 408 L 367.5 405 L 371.5 402 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 215.5 405 L 218 405.5 L 215.5 406 L 215.5 405 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 294.5 405 L 297 405.5 L 294.5 406 L 294.5 405 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 219.5 406 L 222 406.5 L 219.5 407 L 219.5 406 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 290.5 406 L 293 406.5 L 290.5 407 L 290.5 406 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 223.5 407 L 227 407.5 L 223.5 408 L 223.5 407 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 285.5 407 L 289 407.5 L 285.5 408 L 285.5 407 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 148.5 408 L 159 415.5 L 157.5 415 Q 150.4 412.7 148.5 408 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 228.5 408 L 232 408.5 L 228.5 409 L 228.5 408 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 280.5 408 L 284 408.5 L 280.5 409 L 280.5 408 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 363.5 408 L 361.5 411 L 353.5 416 L 354.5 414 L 363.5 408 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 234.5 409 L 240 409.5 L 234.5 410 L 234.5 409 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 272.5 409 L 278 409.5 L 272.5 410 L 272.5 409 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 243.5 410 L 269 410.5 L 243.5 411 L 243.5 410 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 160.5 416 L 166 419.5 L 164.5 419 Q 160.5 418.5 160.5 416 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 351.5 416 L 350.5 418 L 346.5 420 L 347.5 418 L 351.5 416 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 167.5 420 L 176 424.5 L 174.5 425 L 168.5 422 L 167.5 420 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 342.5 421 L 341.5 423 L 334.5 426 L 334.5 425 L 342.5 421 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 179.5 426 L 185 428.5 L 183.5 429 L 179.5 427 L 179.5 426 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 331.5 426 L 333 426.5 L 327.5 429 L 327.5 428 L 331.5 426 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 186.5 429 L 190 430.5 L 188.5 431 L 186.5 429 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 324.5 429 L 326 429.5 L 322.5 431 L 322.5 430 L 324.5 429 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 203.5 435 L 206 435.5 L 203.5 436 L 203.5 435 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 306.5 435 L 309 435.5 L 306.5 436 L 306.5 435 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 210.5 437 L 214 437.5 L 210.5 438 L 210.5 437 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 298.5 437 L 302 437.5 L 298.5 438 L 298.5 437 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 215.5 438 L 218 438.5 L 215.5 439 L 215.5 438 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 294.5 438 L 297 438.5 L 294.5 439 L 294.5 438 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 219.5 439 L 223 439.5 L 219.5 440 L 219.5 439 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 289.5 439 L 293 439.5 L 289.5 440 L 289.5 439 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 225.5 440 L 230 440.5 L 225.5 441 L 225.5 440 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 282.5 440 L 287 440.5 L 282.5 441 L 282.5 440 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 232.5 441 L 238 441.5 L 232.5 442 L 232.5 441 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 274.5 441 L 280 441.5 L 274.5 442 L 274.5 441 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(27,38,75)",
    stroke: "rgb(27,38,75)",
    strokeWidth: 1,
    opacity: 0.6352941176470588,
    d: "M 241.5 442 L 271 442.5 L 241.5 443 L 241.5 442 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(28,39,76)",
    stroke: "rgb(28,39,76)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 251.5 70 L 260.5 70 L 270 77.5 L 272 83.5 L 272.5 260 L 311.5 221 Q 315.5 218 323.5 219 Q 330 220.5 333 225.5 L 336 232.5 L 336 236.5 L 334 242.5 L 264.5 312 Q 260.5 315.5 251.5 314 L 248.5 313 L 178 242.5 L 176 232.5 Q 177.8 224.8 183.5 221 Q 187.5 218 195.5 219 L 200.5 221 L 239.5 260 L 240 83.5 Q 241.6 74.6 248.5 71 L 251.5 70 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(28,39,76)",
    stroke: "rgb(28,39,76)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 83.5 240 Q 94.8 240.2 99 247.5 L 101 252.5 L 101 266.5 L 102 267.5 L 102 276.5 L 105 292.5 L 113 316.5 Q 125.8 346.2 147.5 367 Q 168.3 387.7 197.5 400 L 215.5 406 L 234.5 410 L 242.5 410 L 243.5 411 L 268.5 411 L 300.5 405 L 321.5 397 Q 349.9 383.4 370 361.5 Q 388.6 341.6 400 314.5 L 405 300.5 L 409 283.5 L 410 269.5 L 411 268.5 L 411 252.5 L 417.5 243 Q 421.5 240 428.5 240 Q 436.6 241.4 440 247.5 L 442 251.5 L 442 274.5 L 436 306.5 Q 429.6 329.1 419 347.5 Q 402.6 376.1 378.5 397 Q 350.2 422.2 309.5 435 L 288.5 440 L 274.5 441 L 273.5 442 L 238.5 442 L 237.5 441 L 223.5 440 L 202.5 435 Q 183 429 166.5 420 Q 137.2 403.8 116 379.5 Q 93.9 355.1 81 321.5 L 75 302.5 L 71 281.5 L 70 251.5 L 77.5 242 L 83.5 240 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.69f9377bb26b0181b8f369563f7fff28.svg";
export { ForwardRef as ReactComponent };